// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

const parseMacroParams = ($macroContainer) => {
	const macroParamsString = $macroContainer.attr('data-macro-parameters') || '',
		valuePairs = macroParamsString.split('|'),
		macroParams = {};

	if (valuePairs) {
		$.each(valuePairs, (valuePairIdx, valuePair) => {
			const valuePairTokens = valuePair.split('=', 2);
			if (valuePairTokens.length > 0) {
				macroParams[valuePairTokens[0]] = valuePairTokens.length > 1 ? valuePairTokens[1] : '';
			}
		});
	}

	return macroParams;
};

const getMacroName = ($macroContainer) => {
	return $macroContainer.attr('data-macro-name');
};

const initViewButtons = () => {
	$.each(getButtonIdToViewMap(), (buttonId, buttonValue) => {
		window.AJS.Confluence.PropertyPanel.Macro.registerButtonHandler(buttonId, (e, macroNode) => {
			const $macroContainer = $(macroNode);
			window.AJS.Rte.getEditor().selection.select($macroContainer[0]);
			window.AJS.Rte.BookmarkManager.storeBookmark();

			window.tinymce.confluence.MacroUtils.insertMacro({
				contentId: window.Confluence.Editor.getContentId(),
				macro: {
					name: getMacroName($macroContainer),
					params: $.extend(parseMacroParams($macroContainer), {
						defaultView: buttonValue,
					}),
					defaultParameterValue: '',
					body: '',
				},
			});
		});
	});
};

const initAddButton = () => {
	window.AJS.Confluence.PropertyPanel.Macro.registerButtonHandler(
		'add-subcalendar',
		(e, macroNode) => {
			const $macroContainer = $(macroNode);
			window.Confluence.TeamCalendars.Dialogs.getAddDialogForMacro({
				name: getMacroName($macroContainer),
				params: parseMacroParams($macroContainer),
				defaultParameterValue: '',
				body: '',
			});
		},
	);
};

const getButtonIdToViewMap = () => ({
	'calendar-view-month': 'month',
	'calendar-view-week': 'week',
	'calendar-view-list': 'list',
	'calendar-view-upcoming': 'upcoming',
	'calendar-view-timeline': 'timeline',
});

const initViewButtonHighlight = () => {
	bind('created.property-panel', (e, data) => {
		let viewButtonToHighlight = parseMacroParams($(data.anchor))['defaultView'] || 'month';
		if (viewButtonToHighlight === 'upcoming') {
			viewButtonToHighlight = 'list';
		}

		$(`.macro-property-panel-calendar-view-${viewButtonToHighlight}`, data.panel).addClass(
			'selected',
		);
	});
};

const runInit = function () {
	initViewButtons();
	initAddButton();
	initViewButtonHighlight();
};

const init = () => {
	bind('init.rte', runInit);
};
export default init;
